import type { DeviceType, PlatformType } from '@weberus/shared-types';
import { Device, Platform } from '@weberus/shared-types';
import { atom } from 'jotai';

interface DeviceInformation {
  deviceType: DeviceType;
  platformType: PlatformType;
  appType?: DeviceType | null;
}

const initialDeviceState = {
  deviceType: Device.etc,
  platformType: Platform.Web,
  appType: null,
} as const;

export const deviceAtom = atom<DeviceInformation>(initialDeviceState);

/* 실험 그룹 정보 */
export const expGroupsAtom = atom<string | null>(null);

/**
 * 하이브리드 앱 환경에서 실제 앱의 타입을 나타냅니다. (iOS 또는 Android)
 * 앱이 아닌 환경에서는 undefined 입니다.
 */
export const appDeviceAtom = atom<'ios' | 'android' | undefined>();

interface PcWidthState {
  isPcWidth: boolean;
  initialized: boolean;
}

/* PC/모바일 너비 구분을 위한 상태 */
export const pcWidthAtom = atom<PcWidthState>({ isPcWidth: false, initialized: false });

/* 테스트 상품 노출 여부를 위한 상태 */
export const testProductAtom = atom<'NO' | 'YES' | 'ONLY' | null>();
